import {useState} from 'react';
import CustomButton from '../../../../components/customButton';
import FormikInputField from '../../../../components/formikFileds/FormikInputField';
import FormikSelectField from '../../../../components/formikFileds/formikSelectField';
import {
  addCommas,
  removeNonNumeric,
} from '../../../../utilities/helper/numberHelper';
import {toEnglishDigits} from '../../../../utilities/helper/toEnglishNumber';
import convertNumberToPersianExactUnits from '../../../../utilities/helper/unitConvertor/convertNumberToPersianExactUnits';
import Num2persian from '../../../../utilities/helper/convertNumToPersian';

const completeRepayDurationOptions = [
  {label: '3 ماه', value: '3'},
  {label: '6 ماه', value: '6'},
  {label: '9 ماه', value: '9'},
  {label: '12 ماه', value: '12'},
  {label: '18 ماه', value: '18'},
  {label: '24 ماه', value: '24'},
  {label: '30 ماه', value: '30'},
  {label: '36 ماه', value: '36'},
];

const repayIntervalDurationOptions = [
  {label: '1 ماه', value: '1'},
  {label: '3 ماه', value: '3'},
  {label: '6 ماه', value: '6'},
  {label: '9 ماه', value: '9'},
  {label: '12 ماه', value: '12'},
];

const LoanForm = ({formik, isLoading}: {formik: any; isLoading: boolean}) => {
  const [amountInLetter, setAmountInLetter] = useState<string>();

  return (
    <form
      onSubmit={formik.handleSubmit}
      className="flex flex-col flex-1 gap-2 p-6"
    >
      <FormikInputField
        name="amount"
        label="مبلغ وام درخواستی (تومان)"
        placeholder="مبلغ وام درخواستی را بنویسید (تومان)"
        required
        formik={formik}
        type="text"
        inputMode="numeric"
        onChangeFormatter={val => {
          const english = toEnglishDigits(val);
          const numeric = removeNonNumeric(english);
          return addCommas(numeric);
        }}
        onValueChange={value => setAmountInLetter(Num2persian(value))}
      />
      {amountInLetter && (
        <div className="mr-3 -mt-2 text-sm text-gray-600">
          {amountInLetter} تومان{' '}
        </div>
      )}

      <FormikSelectField
        name="total_repayment_time"
        label="کل زمان بازپرداخت"
        placeholder="انتخاب کنید"
        required
        formik={formik}
        options={completeRepayDurationOptions}
      />

      <FormikSelectField
        name="repayment_interval"
        label="فاصله میان بازپرداخت اقساط"
        placeholder="انتخاب کنید"
        required
        formik={formik}
        options={repayIntervalDurationOptions}
      />

      <div className="relative ">
        <FormikInputField
          name="loan_rate"
          label="نرخ سود وام (درصد)"
          placeholder="نرخ سود وام (درصد) را وارد کنید"
          required
          formik={formik}
          type="text"
          inputMode="numeric"
          onChangeFormatter={val => {
            const english = toEnglishDigits(val);
            const numeric = removeNonNumeric(english);
            return numeric;
          }}
        />

        {formik.values.loan_rate && (
          <span className="absolute text-gray-500 left-3 top-[2.75rem] ">
            درصد
          </span>
        )}
      </div>

      <div className="mt-auto">
        <CustomButton
          title="محاسبه"
          isLoading={isLoading}
          type="submit"
          disabled={!formik.isValid}
          className="py-3 !text-lg"
        />
      </div>
    </form>
  );
};

export default LoanForm;
